import { 
  EnforcedButtonType, 
  EnforcedOkTextType, 
  EnforcedCancelTextType 
} from './types';

/**
 * Constants for Button types. 
 * Using branded types forces usage of these tokens instead of raw strings.
 */
export const ENFORCED_BUTTON_TYPES = {
  PRIMARY: 'primary' as EnforcedButtonType,
  DANGER: 'danger' as EnforcedButtonType,
  DEFAULT: 'default' as EnforcedButtonType,
  DASHED: 'dashed' as EnforcedButtonType,
  LINK: 'link' as EnforcedButtonType,
  TEXT: 'text' as EnforcedButtonType,
} as const;

/**
 * Constants for Modal button text to prevent hardcoded string regressions.
 */
export const ENFORCED_MODAL_TEXT_YES = {
  YES: 'Yes' as EnforcedOkTextType,
  OK: 'OK' as EnforcedOkTextType,
  DELETE: 'Delete' as EnforcedOkTextType,
  RESET: 'Reset' as EnforcedOkTextType,
} as const;

export const ENFORCED_MODAL_TEXT_NO = {
  NO: 'No' as EnforcedCancelTextType,
  CANCEL: 'Cancel' as EnforcedCancelTextType,
} as const;
